import {remCalc} from '_themeUtils'

const productStickybar = {
    ProductStickybar: {
        baseStyle: () => ({
            stickybarWrapper: {
                w: '100%',
                py: 'spacing.2',
                px: 'spacing.4',
                columnGap: 'spacing.4',
                border: '1px solid',
            },
            stickyName: {
                textStyle: 'paragraphMd',
                fontWeight: 'normal',
            },
            stickyColorSelector: {
                mr: 0,
                ml: 'auto',
            },
            stickyColourButton: {
                textStyle: 'paragraphSm',
                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
            colourSelectorPopover: {
                w: {base: '100%', md: 'auto'},
                bottom: {base: 0, md: remCalc(10)},
                right: {base: 0, md: remCalc(0)},
                // Figma 58078-29415 (Colors): popover padding 20px, full outer stroke
                // color/border/default (#262626 → color.border.black) and 8px radius — same treatment as
                // the size popover.
                p: 'spacing.5',
                border: '1px solid',
                borderColor: 'color.border.black',
                borderRadius: remCalc(8),
                maxH: '70vh',
                overflow: 'auto',
            },
            // Figma "Color dots" outer box (24px). Two-ring visual handled by ColorCircle (`selected`).
            swatchItem: {
                position: 'relative',
                w: remCalc(24),
                h: remCalc(24),
                flexShrink: 0,
            },
            stickySizeSelector: {},
            stickyAddToCartWrapper: {
                w: remCalc(180),
            },
            sizeSelectorPopover: {
                w: {base: '100%', md: remCalc(410)},
                // Align the popover's distance from the sticky bar with the color popover (10px) — Figma
                // places both selectors the same distance above the bar. Previously 30px, which made the
                // size popover float noticeably higher than the color one.
                bottom: {base: 0, md: remCalc(10)},
                // Figma 58078-29414 (Taglie): popover padding 30px, full outer stroke
                // color/border/default (#262626 → color.border.black) and 8px radius. (Fixes the previous
                // `rigth` typo, which set a dead property and never applied a right offset.)
                right: {base: 0, md: remCalc(0)},
                p: remCalc(30),
                maxH: '70vh',
                overflow: 'auto',
                border: '1px solid',
                borderColor: 'color.border.black',
                borderRadius: remCalc(8),
            },
            stickySizeButton: {
                textStyle: 'paragraphSm',
                _firstLetter: {
                    textTransform: 'capitalize',
                },
            },
        }),
    },
}

export default productStickybar
